// blakfy-cookie/src/i18n/translations/nl.js — Dutch translations

export default {
  title: "Cookie-voorkeuren",
  intro:
    "Deze site gebruikt cookies om uw ervaring te verbeteren. Zie ons Cookiebeleid voor details.",
  policyLink: "Cookiebeleid",
  acceptAll: "Alles accepteren",
  rejectAll: "Alles weigeren",
  preferences: "Voorkeuren",
  save: "Keuzes opslaan",
  close: "Sluiten",
  cat: {
    essential: {
      title: "Essentiële cookies",
      desc: "Noodzakelijk voor het functioneren van de site. Kunnen niet worden uitgeschakeld.",
      always: "Altijd actief",
    },
    analytics: {
      title: "Analytische cookies",
      desc: "Gebruikt voor het verzamelen van anonieme bezoekstatistieken.",
    },
    marketing: {
      title: "Marketingcookies",
      desc: "Gebruikt voor gepersonaliseerde advertenties en retargeting.",
    },
    functional: {
      title: "Functionele cookies",
      desc: "Gebruikt om voorkeuren zoals taal en thema te onthouden.",
    },
  },
  placeholder: {
    title: "Inhoud geblokkeerd",
    desc: "U moet {category}-cookies toestaan om deze inhoud te bekijken.",
    cta: "Toestaan",
  },
  tabs: {
    categories: "Categories",
    services: "Services",
    about: "About",
  },
  service: {
    description: "Description",
    processor: "Data Processor",
    address: "Address",
    dpo: "DPO Contact",
    purposes: "Purposes",
    technologies: "Technologies Used",
    dataCollected: "Data Collected",
    legalBasis: "Legal Basis",
    retention: "Retention Period",
    transferCountries: "Transfer Countries",
    privacyPolicy: "Privacy Policy",
    cookiePolicy: "Cookie Policy",
    legalBasisValues: {
      consent: "Consent (Art. 6 para. 1 s. 1 lit. a GDPR)",
      legitimate_interest: "Legitimate Interest (Art. 6 para. 1 s. 1 lit. f GDPR)",
    },
    noServices: "No services are configured for this site.",
  },
  svcAbout: {
    title: "About this CMP",
    description:
      "This website uses Blakfy Cookie Management Platform (CMP) to manage your consent preferences in compliance with GDPR, KVKK, CCPA and other applicable privacy regulations.",
    version: "Version",
    learnMore: "Learn more at blakfy.com",
  },
};
